import React, { ReactElement, createContext, useContext, useMemo } from 'react';

import brands from './brands';
import { BrandContextType } from './common/types/BrandContextType';
import { resolveBrandCountry } from './common/utils/resolveBrandCountry';

export const brandingContext = createContext<BrandContextType | undefined>(undefined);

type BrandingContextProps = {
  children: ReactElement,
};

export function BrandingContext({ children }: BrandingContextProps) {
  const contextValue = useMemo(() => {
    const { brand } = resolveBrandCountry();

    switch (brand) {
      default: return brands.app();
    }
  }, [ ]);

  return (
    <brandingContext.Provider value={contextValue}>
      {children}
    </brandingContext.Provider>
  );
}

export const useBrandingContext = () => useContext(brandingContext)!;
